(() => {
  'use strict';
  if (window.nnBundleBuilderLoaded) return;
  window.nnBundleBuilderLoaded = true;
  const normalizeColor = value => ({ grey: 'Gray', gray: 'Gray', pink: 'Pink', beige: 'Beige' })[String(value || '').trim().toLowerCase()] || '';
  const readJSON = element => {
    try { return JSON.parse(element?.textContent || 'null'); } catch (_) { return null; }
  };
  const boot = (scope = document) => {
    const builders = [...scope.querySelectorAll('[data-bundle-builder]')];
    if (scope.matches?.('[data-bundle-builder]')) builders.unshift(scope);
    builders.forEach(builder => {
      if (builder.dataset.ready) return;
      const root = builder.closest('[data-product-section]');
      const form = builder.closest('form');
      const variants = readJSON(root?.querySelector('[data-variant-data]'));
      const imageData = readJSON(root?.querySelector('[data-product-image-data]')) || {};
      const moneyData = readJSON(builder.querySelector('[data-bundle-money]')) || [];
      const variantSelect = builder.querySelector('[data-bundle-variant]');
      const addButton = root?.querySelector('[data-add-to-cart]');
      if (!root || !form || !Array.isArray(variants) || !variantSelect || !addButton) return;
      builder.dataset.ready = 'true';
      const colorIndex = Number(builder.dataset.colorIndex);
      const packIndex = Number(builder.dataset.packIndex);
      const packOf = variant => parseInt(variant?.options?.[packIndex], 10);
      const colorOf = variant => normalizeColor(variant?.options?.[colorIndex]);
      const getVariant = (color, count) => variants.find(variant => colorOf(variant) === color && packOf(variant) === count);
      const packInputs = [...builder.querySelectorAll('[data-bundle-pack]')];
      const pieces = [...builder.querySelectorAll('[data-bundle-piece]')];
      const confirmation = builder.querySelector('[data-bundle-confirmation]');
      const productStatus = root.querySelector('[data-product-status]');
      let pack = Number(builder.dataset.initialPack) || 1;
      const initialColor = normalizeColor(builder.dataset.initialColor) || 'Pink';
      const state = pieces.map(() => ({ color: initialColor, size: '' }));
      let attempted = false;
      const allowedSizes = ['M', '4XL'];
      const setImage = (src, alt, imageId, illustration = false, fullSrc = src) => {
        if (!src) return;
        const image = root.querySelector('[data-main-image]');
        const link = root.querySelector('[data-main-image-link]');
        if (image) {
          image.src = src;
          image.removeAttribute('srcset');
          image.alt = alt || imageData.featuredAlt || 'Nest & Nuzzle hoodie';
        }
        if (link) link.href = fullSrc;
        const note = root.querySelector('[data-product-art-note]');
        if (note) note.hidden = !illustration;
        root.querySelectorAll('[data-product-thumbnail]').forEach(thumbnail => {
          if (imageId && String(thumbnail.dataset.imageId) === String(imageId)) thumbnail.setAttribute('aria-current', 'true');
          else thumbnail.removeAttribute('aria-current');
        });
      };
      const showColor = color => {
        const variant = getVariant(color, pack) || variants.find(item => colorOf(item) === color && item.image);
        if (variant?.image) setImage(variant.image, variant.alt, variant.imageId);
        else {
          const alternative = variants.find(item => colorOf(item) === color && item.image);
          if (alternative) setImage(alternative.image, alternative.alt, alternative.imageId);
          else if (imageData.fallbacks?.[color.toLowerCase()]) setImage(imageData.fallbacks[color.toLowerCase()], `${color} babywearing hoodie — AI lifestyle illustration`, null, true);
          else setImage(imageData.featuredImage, imageData.featuredAlt, imageData.featuredImageId);
        }
      };
      const render = () => {
        const selectedVariant = getVariant(state[0].color, pack);
        const active = state.slice(0, pack);
        const available = !!selectedVariant?.available && active.every(piece => !!getVariant(piece.color, pack)?.available);
        const complete = active.every(piece => normalizeColor(piece.color) && allowedSizes.includes(piece.size));
        const valid = available && complete;
        packInputs.forEach(input => {
          const count = Number(input.value);
          const variant = getVariant(state[0].color, count);
          input.checked = count === pack;
          input.disabled = !variant?.available;
          const price = builder.querySelector(`[data-pack-price="${count}"]`);
          const saving = builder.querySelector(`[data-pack-saving="${count}"]`);
          if (price) price.textContent = variant?.price || 'Unavailable';
          const amount = moneyData.find(item => String(item.id) === String(variant?.id));
          if (saving) saving.textContent = !variant?.available ? 'Sold out' : count === 1 ? 'One cozy layer' : amount?.saving > 0 ? `Save ${amount.savingLabel}` : 'Mix colors & sizes';
        });
        pieces.forEach((piece, index) => {
          const enabled = index < pack;
          piece.hidden = !enabled;
          piece.querySelectorAll('[data-piece-color]').forEach(input => {
            input.checked = input.value === state[index].color;
            input.disabled = !enabled || !getVariant(input.value, pack)?.available;
          });
          piece.querySelectorAll('[data-piece-size]').forEach(input => {
            input.checked = input.value === state[index].size;
            input.disabled = !enabled || !allowedSizes.includes(input.value);
          });
          const property = piece.querySelector('[data-piece-property]');
          property.disabled = !enabled || !allowedSizes.includes(state[index].size);
          property.value = enabled && state[index].size ? `${state[index].color} / ${state[index].size}` : '';
          piece.querySelector('[data-piece-selection]').textContent = state[index].size ? `${state[index].color} / ${state[index].size}` : 'Choose a size';
        });
        variantSelect.disabled = !selectedVariant;
        variantSelect.value = selectedVariant ? String(selectedVariant.id) : '';
        builder.querySelector('[data-bundle-pack-property]').value = `${pack} ${pack === 1 ? 'piece' : 'pieces'}`;
        builder.querySelector('[data-bundle-total-label]').textContent = `${pack} ${pack === 1 ? 'piece' : 'pieces'} · Pack total`;
        builder.querySelector('[data-bundle-total]').textContent = selectedVariant?.price || 'Unavailable';
        const price = root.querySelector('[data-product-price]');
        const compare = root.querySelector('[data-product-compare]');
        if (price) price.textContent = selectedVariant?.price || 'Unavailable';
        if (compare) { compare.hidden = !selectedVariant?.compare; compare.textContent = selectedVariant?.compare || ''; }
        addButton.disabled = !valid;
        addButton.textContent = !available ? 'Sold out' : complete ? `Add ${pack === 1 ? '1 piece' : `${pack} pieces`} to bag` : 'Choose your size to continue';
        const missing = active.reduce((result, piece, index) => allowedSizes.includes(piece.size) ? result : [...result, index + 1], []);
        const message = !available ? 'This pack selection is currently sold out.' : complete ? 'Your colors and sizes will be included with your order.' : `Choose a size for ${missing.map(number => `piece ${number}`).join(' and ')}.`;
        confirmation.textContent = message;
        confirmation.classList.toggle('is-ready', valid);
        confirmation.classList.toggle('is-error', attempted && !valid);
        if (productStatus) productStatus.textContent = '';
        const dynamicCheckout = root.querySelector('[data-dynamic-checkout]');
        if (dynamicCheckout) dynamicCheckout.hidden = true;
        if (selectedVariant && !document.body.classList.contains('nn-design-mode')) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', selectedVariant.id);
          window.history.replaceState(window.history.state, '', url);
        }
        return valid;
      };
      builder.addEventListener('change', event => {
        const input = event.target;
        if (input.matches('[data-bundle-pack]')) {
          pack = Number(input.value);
          render();
          showColor(state[0].color);
        } else if (input.matches('[data-piece-color], [data-piece-size]')) {
          const index = Number(input.closest('[data-bundle-piece]').dataset.bundlePiece) - 1;
          if (input.matches('[data-piece-color]')) state[index].color = normalizeColor(input.value);
          else state[index].size = allowedSizes.includes(input.value) ? input.value : '';
          render();
          if (input.matches('[data-piece-color]')) showColor(state[index].color);
        }
      });
      form.addEventListener('submit', event => {
        attempted = true;
        if (!render()) {
          event.preventDefault();
          const missingIndex = state.slice(0, pack).findIndex(piece => !allowedSizes.includes(piece.size));
          const target = pieces[missingIndex]?.querySelector('[data-piece-size]:not(:disabled)');
          target?.focus();
          target?.closest('[data-bundle-piece]')?.scrollIntoView({ block: 'center', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        }
      });
      root.querySelectorAll('[data-product-thumbnail]').forEach(thumbnail => thumbnail.addEventListener('click', event => {
        event.preventDefault();
        setImage(thumbnail.dataset.imageSrc, thumbnail.dataset.imageAlt, thumbnail.dataset.imageId, false, thumbnail.href);
      }));
      render();
      showColor(state[0].color);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(), { once: true });
  else boot();
  document.addEventListener('shopify:section:load', event => boot(event.target));
})();
